class Config {
    constructor() {
        Object.defineProperty(this, "apiUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoClientUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoTransferSessionUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "diilCrmUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "faceBookUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brandfreeGdprUrlWithReturnUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "diilWebUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kerUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "standingOrderUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billingAddressUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentMonthBalanceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packetUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "additionalMobileData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "friendCountryUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "callsToRussiaUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "roamingUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "voiceMailUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "additionalServicesUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newSimUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "simUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "servicesUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ordersUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sendSmsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prepaidCardTopupUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newServiceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "offersSettingsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "joinDiilUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "linkExistingMobileUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oldSelfserviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selfServiceSettingsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "teliaSelfServiceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "preferencesUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "credentialsAllowed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billsPayButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gdprUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rumBeaconUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rumClientToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rumDebugEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    initialize(config) {
        this.environment = config.environment;
        this.apiUrl = config.apiUrl;
        this.ssoClientUrl = config.ssoClientUrl;
        this.ssoTransferSessionUrl = config.ssoTransferSessionUrl;
        this.diilCrmUrl = config.diilCrmUrl;
        this.faceBookUrl = config.faceBookUrl;
        this.brandfreeGdprUrlWithReturnUrl = config.brandfreeGdprUrlWithReturnUrl;
        this.diilWebUrl = config.diilWebUrl;
        this.kerUrl = config.kerUrl;
        this.standingOrderUrl = config.standingOrderUrl;
        this.billingAddressUrl = config.billingAddressUrl;
        this.billsUrl = config.billsUrl;
        this.currentMonthBalanceUrl = config.currentMonthBalanceUrl;
        this.packetUrl = config.packetUrl;
        this.additionalMobileData = config.additionalMobileData;
        this.friendCountryUrl = config.friendCountryUrl;
        this.callsToRussiaUrl = config.callsToRussiaUrl;
        this.roamingUrl = config.roamingUrl;
        this.voiceMailUrl = config.voiceMailUrl;
        this.additionalServicesUrl = config.additionalServicesUrl;
        this.newSimUrl = config.newSimUrl;
        this.simUrl = config.simUrl;
        this.servicesUrl = config.servicesUrl;
        this.deviceUrl = config.deviceUrl;
        this.contractsUrl = config.contractsUrl;
        this.ordersUrl = config.ordersUrl;
        this.sendSmsUrl = config.sendSmsUrl;
        this.prepaidCardTopupUrl = config.prepaidCardTopupUrl;
        this.newServiceUrl = config.newServiceUrl;
        this.userUrl = config.userUrl;
        this.offersSettingsUrl = config.offersSettingsUrl;
        this.preferencesUrl = config.preferencesUrl;
        this.joinDiilUrl = config.joinDiilUrl;
        this.linkExistingMobileUrl = config.linkExistingMobileUrl;
        this.oldSelfserviceUrl = config.oldSelfserviceUrl;
        this.selfServiceSettingsUrl = config.selfServiceSettingsUrl;
        this.teliaSelfServiceUrl = config.teliaSelfServiceUrl;
        this.credentialsAllowed = config.credentialsAllowed;
        this.billsPayButton = config.billsPayButton;
        this.gdprUrl = config.gdprUrl;
        this.rumBeaconUrl = config.rumBeaconUrl;
        this.rumClientToken = config.rumClientToken;
        this.rumDebugEnabled = config.rumDebugEnabled;
    }
}
export default new Config();
